import {
  usePartnerSessionCanAccessModule,
  usePartnerSessionCanEditModule,
} from "./usePartnerSessionPermissions";
import { PARTNER_PORTAL_PERMISSION_KEYS as PP_KEYS } from "../utils/permissions/partnerPortalPermissionKeys";

/** Timeline step UI: view shows controls disabled; na hides via canAccessTimeline. */
export function useTimelineStepPermissions(isFormDisabled = false) {
  const canAccessTimeline = usePartnerSessionCanAccessModule(
    PP_KEYS.TIMELINE_MANAGEMENT
  );
  const canEditTimeline = usePartnerSessionCanEditModule(
    PP_KEYS.TIMELINE_MANAGEMENT
  );
  const canAccessNotesHistory = usePartnerSessionCanAccessModule(
    PP_KEYS.NOTES_HISTORY
  );
  const timelineLocked = isFormDisabled || !canEditTimeline;

  const resolveCommentsModalMode = (
    mode: "view" | "add" | "edit"
  ): "view" | "add" | "edit" =>
    timelineLocked && mode !== "view" ? "view" : mode;

  return {
    canAccessTimeline,
    canEditTimeline,
    canAccessNotesHistory,
    timelineLocked,
    resolveCommentsModalMode,
  };
}
